import * as z from "zod";

export const alertFormSchema = z
  .object({
    frequency: z.enum(["immediate", "weekly", "monthly"]),
    send_email: z.boolean(),
    alert_type: z.enum(["new_dilemma", "focus_dilemma", "admin_action"]),
    dilemma: z.string().optional(),
    title: z.string().min(1),
    message: z.string().min(1),
    is_active: z.boolean(),
  })
  .refine((d) => d.alert_type !== "focus_dilemma" || !!d.dilemma, {
    path: ["dilemma"],
    message: "Ce champ est requis",
  });
